module.exports = __webpack_public_path__ + "static/media/station-sample.1e90c678.png";